import { Injectable } from '@angular/core';
import { Http} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx'; //BehaviorSubject
import { EventEmitter} from '@angular/core';

@Injectable()
export class TeamServices {
    private apiUrl = `${environment.apiUrl}/api/v1`;

    public teamEventEmitter: EventEmitter<any> = new EventEmitter();

    //public teamNo: BehaviorSubject<number> = new BehaviorSubject(null);

    teamUseBool = true;
    teamNo: number;
    teamType = 'TT004';
    constructor(private http: Http) {}

    public setTeamNo(teamInfo): void {
        //this.teamNo.next(teamNo);
        this.teamNo = teamInfo.no;
        this.teamType = teamInfo.type;
        this.teamEventEmitter.emit(teamInfo);
    }

    public getTeamNo(): number {
        return this.teamNo;
    }

    public onTeamChange(): Observable<number> {
        return this.teamEventEmitter;
        //return this.teamNo.asObservable();
    }

    public setTeamUseBool(teamUseBool) {
        this.teamUseBool = teamUseBool;
    }

    public getTeamUseBool(): boolean {
        return this.teamUseBool;
    }
    /**
     * team
     * Team 리스트 조회
     * Method : Get
     * API No : 14.1
     * /api/v1/{cmpnNo}/team?searchWord={searchWord}&page={page}&rows={rows}&oidx={oidx}&type={type}
     */
    getTeamList(queryString: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/team?${queryString}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * team
     * Team 등록
     * Method : Post
     * API No : 14.2
     * /api/v1/{cmpnNo}/team
     **/
    createTeam(postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/team`;

        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * team
     * Team 상세 조회
     * Method : Get
     * API No : 14.3
     * /api/v1/{cmpnNo}/team/{teamNo}
     */
    getTeam(teamNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/team/${teamNo}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * team
     * Team 수정
     * Method : Put
     * API No : 14.4
     * /api/v1/{cmpnNo}/team/{teamNo}
     **/
    updateTeam(teamNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/team/${teamNo}`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * team
     * User 리스트
     * Method : Get
     * API No : 14.5
     * /api/v1/{cmpnNo}/team/{teamNo}/user?searchWord={searchWord}&page={page}&rows={rows}&oidx={oidx}
     */
    getTeamUserList(teamNo, queryString: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/team/${teamNo}/user?${queryString}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * team
     * User 수정
     * Method : Put
     * API No : 14.6
     * /api/v1/{cmpnNo}/team/{teamNo}/user
     **/
    updateTeamUser(teamNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/team/${teamNo}/user`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * team
     * User 제외
     * Method : Delete
     * API No : 14.7
     * /api/v1/{cmpnNo}/team/{teamNo}/user/{userNo}
     **/
    deleteTeamUser(teamNo, userNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/team/${teamNo}/user/${userNo}`;

        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * team
     * Escalation 리스트
     * Method : Get
     * API No : 14.8
     * /api/v1/{cmpnNo}/team/{teamNo}/escalation?searchWord={searchWord}&page={page}&rows={rows}&oidx={oidx}
     */
    getTeamEscalationList(teamNo, queryString: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/team/${teamNo}/escalation?${queryString}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * team
     * Escalation 수정
     * Method : Put
     * API No : 14.9
     * /api/v1/{cmpnNo}/team/{teamNo}/escalation
     **/
    updateTeamEscalation(teamNo, putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/team/${teamNo}/escalation`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * team
     * Escalation 제외
     * Method : Delete
     * API No : 14.10
     * /api/v1/{cmpnNo}/team/{teamNo}/escalation/{escalPlcyNo}
     **/
    deleteTeamEscalation(teamNo, escalPlcyNo) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/team/${teamNo}/escalation/${escalPlcyNo}`;

        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * team
     * Service 리스트
     * Method : Get
     * API No : 14.11
     * /api/v1/{cmpnNo}/team/{teamNo}/service?searchWord={searchWord}&oidx={oidx}
     */
    getTeamServiceList(teamNo, queryString: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/team/${teamNo}/service?${queryString}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * team
     * Team 삭제
     * Method : Delete
     * API No : 14.12
     * /api/v1/{cmpnNo}/team/{teamNo}?newTeamNo={newTeamNo}
     **/
    deleteTeam(teamNo, queryString?: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/team/${teamNo}?${queryString}`;

        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * team
     * User Team Role 수정
     * Method : Put
     * API No : 14.13
     * /api/v1/{cmpnNo}/team/{teamNo}/user/{userNo}
     **/
    updateUserTeamRole(teamNo, userNo, putData) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/team/${teamNo}/user/${userNo}`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/team.services.ts